<div class="container-fluid">
  <!-- Loading overlay -->
  <div *ngIf="isBusy" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2">Loading reports...</p>
  </div>

  <!-- Reports Grid -->
  <div *ngIf="!isBusy" class="row">
    <div class="col-md-4" *ngFor="let report of reports">
      <div class="card mb-3">
        <div class="card-header">
          <strong>{{ report.reportName }}</strong>
        </div>
        <div class="card-body">
          <p class="card-text">{{ report.description }}</p>
          <div class="text-right">
            <button mdbBtn class="relative waves-light btn-sm" color="trakly-action" (click)="onDownloadClick(report)" [disabled]="isBusy">
              <i class="fas fa-download mr-1"></i>
              Download CSV
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isBusy && reports.length === 0" class="text-center my-5">
    <p class="text-muted">No reports available.</p>
  </div>
</div>

<!-- Parameter Input Modal -->
<div mdbModal #paramModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="paramModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100" id="paramModalLabel">{{ selectedReport?.reportName }} - Parameters</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="onModalCancel()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mb-4">{{ selectedReport?.description }}</p>

        <form #reportForm="ngForm">
          <div *ngFor="let param of selectedReport?.parameters" class="mb-3">
            <!-- Text, Number, DateTime inputs -->
            <div *ngIf="param.type !== 'bool'" class="md-form">
              <input
                [type]="getInputType(param.type)"
                [name]="param.name"
                [id]="param.name"
                [required]="param.required"
                [step]="getInputStep(param.type)"
                [(ngModel)]="parameterValues[param.name]"
                mdbInput
                class="form-control"
              />
              <label [for]="param.name">
                {{ param.name }}
                <span *ngIf="param.required" class="text-danger">*</span>
              </label>
            </div>

            <!-- Checkbox for boolean -->
            <div *ngIf="param.type === 'bool'" class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [name]="param.name"
                [id]="param.name"
                [(ngModel)]="parameterValues[param.name]"
              />
              <label class="form-check-label" [for]="param.name">
                {{ param.name }}
                <span *ngIf="param.required" class="text-danger">*</span>
              </label>
            </div>
          </div>
        </form>

        <div class="text-muted small mt-3"><span class="text-danger">*</span> Required fields</div>
      </div>
      <div class="modal-footer">
        <button mdbBtn type="button" color="secondary" class="relative waves-light" (click)="onModalCancel()" [disabled]="isBusy">
          Cancel
        </button>
        <button
          mdbBtn
          type="button"
          color="trakly-action"
          class="relative waves-light"
          (click)="onModalSubmit()"
          [disabled]="isBusy || !reportForm.valid"
        >
          <span *ngIf="isBusy" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
          <span *ngIf="!isBusy">Execute & Download</span>
          <span *ngIf="isBusy">Executing...</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Error Component -->
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
